// extracted by mini-css-extract-plugin
export default {"root":"IconCircleClose_root__pzFGY"};